export default () => {
  const data = {
    event_name: 'click',
    button_name: 'ordination',
    page_section: 'ordination_section',
    name_of_the_page_viewed: 'development_list_personal',
  };
  return data;
};
